import LocalizedStrings from 'react-localization';
// import { totalmem } from 'os';
import { DEVELOPMENT_TYPE } from '../components/Common/constant';

// --------- NOTE -----------
// IF UPDATING LANGUAGE FILE ONLY UPDATE THE TEXTS NOT THE DOUBLE QUOTES ('') OR BACK-TICS (``)

const LocalStrings = new LocalizedStrings({
  en: {
    // login_form_label_password:
    //   DEVELOPMENT_TYPE === 'koachify' ? 'Password' : 'Passcode / Eventcode',
    // login_form_ph_password:
    //   DEVELOPMENT_TYPE === 'koachify'
    //     ? 'Enter your password'
    //     : 'Enter passcode / eventcode',
    // kOverviewText: DEVELOPMENT_TYPE === 'koachify' ? 'All Courses' : 'Overview',
    // kSessionsText:
    //   DEVELOPMENT_TYPE === 'koachify' ? 'Live Classes' : 'Sessions',

    // ==============================================
    // Existing language properties starts
    // ==============================================
    Admin: '',
    kUpdateProfile: 'Update profile',
    kProfileCompleteText: 'Profile Complete',
    KProfileCompleteMsg:
      "Your profile is complete! We look forward to seeing you there. We'll use your preferences and contact information to help you get the most out of the",
    kUpdatePassword: 'Update password',
    kPassword: 'Password',
    kAttendeeSearchTxt: 'Search and Filter',
    kAttendeeSearchHintTxt: 'Enter name or keyword',
    kWelcomeMailSent: 'Welcome mail sent successfully',
    kAccessAllowed: 'Access allowed successfully',
    kMap: 'Map',
    kPhone: 'Phone',
    kEmail: 'E-mail',
    kGallery: 'Gallery',
    kAudio: 'Audio',
    kDoc: 'Doc',
    kClose: 'Close',
    kMore: 'More',
    kVideo: 'Video',
    kBlock: 'Block',
    kBlocked: 'BLOCKED',
    kUnBlock: 'UNBLOCK',
    kAddEdit: 'Add/Edit',
    kNote: 'Note :',
    kFileNotFound: 'File not found...',
    KAddContactPerson: 'Add Contact Person',
    KAddCoupons: 'Add Coupons',
    kAddMaxAttachments: 'You can add a maximum of 10 attachments',
    kGuestUser: 'Guest User',
    kYourAccountHasRemoved:
      'Either your account has been removed or has been made un-accessible due to some other reason. Please Logout',
    kSessionQrScanner: 'Session QR Scanner',
    kEventComingSoon: 'Event will coming soon',
    kVerifyingMagicLink: 'Verifying magic link...',
    kNeedInternetToDeleteMsg:
      'You Need To be Connected to Internet for deleting!!!',
    kNeedInternetToUnblockMsg:
      'You Need To be Connected to Internet for unblocking!!!',
    kDownloadNotesMsg: 'Are you sure you want to download all the notes?',
    kGamificationIsOnMsg: 'Gamification is On! Get Exciting Rewards',
    kSearchByName: 'Search by name',
    kGetStarted: 'Get Started',
    kAlert: 'Alert!',
    KAddfilesText: 'Add Files',
    kSearchNameBoothNo: 'Search by name or booth number',
    kGameAppNotInstalled: 'Gmail App is not installed in your device',
    kYourMessageHere: 'Your message here...',
    koNotifDisable: 'Notifications Are Disabled',
    koTurnOnNotificationMsg:
      'Turning on notifications lets us send you customization alerts and personalized recommendations. You can enable notifications from Settings> Eventify',
    kSearchUserName: 'Search username to check in',
    kCreateNewPost: "What's on your mind?",
    kNeverAskAgain: 'Never ask again',
    kSocialStatus: 'Social Status',
    kSelectOneAnswer: 'Please select one answer',
    KSelectWeekday: 'Select Weekday',
    KSelectDuration: 'Select Duration',
    kHowWasTheSession: 'How was the session?',
    kMessage: 'Message',
    kPleaseRateTheSession: 'Please Rate the Session to improve',
    kWatchPromo: 'Watch Promo',
    kPleaseWait: 'Please wait...',
    kScanAQRCode: 'Scan a QR Code',
    kAddContact: 'Add Contact',
    kNoSessionsFound: 'No Sessions Found',
    KAllSessionAttendees: 'All Session Attendees ',
    kNoSponsorsFound: 'No Sponsors Found',
    kNoExhibitorsFound: 'No Exhibitors Found',
    kHourAgo: 'hour ago',
    kHoursAgo: 'hours ago',
    KHour: 'hour',
    KHours: 'hours',
    Kminute: 'minute',
    Kminutes: 'minutes',
    KShortMin: 'Mins',
    kMinuteAgo: 'minute ago',
    kMinutesAgo: 'minutes ago',
    kSecondsAgo: 'seconds ago',
    kEmailCantBlank: "Email can't be blank",
    KSameTimeError: 'Starting and Ending time cannot be same!',
    KNoAvailableslots: 'No Timeslots Available on',
    kEmailNotValid: 'Email is not valid',
    kAddNote: 'Add a Note',
    kErrorWhileUpdating: 'Error while updating',
    kTurnOnNotificationMsg:
      'Turning on notifications lets us send you customization alerts and personalized recommendations',
    kStatsOnlyVisibleMsg:
      '*Stats is only visible to the associated exhibitor(s) and the event host',
    kByBoothNumber: 'by booth number',
    kFindConnections: 'Find Connections',
    kCheckInternetConnection: 'Please check your internet connection',
    kDisConnectedCheckInternet:
      'You are disconnected! Please check your internet connection.',
    kAppearSoonBookmarkMsg:
      'will appear as soon as they are bookmarked. Please check back later.',
    kUnableToFetchDataMsg:
      'No internet connection. We are unable to refresh the data',
    kAppearSoonMsg:
      'will appear as soon as they are added. Please check back later',
    kConnected: 'Connected',
    kMagicLinkExpired: 'Magic link expired.',
    kLastReplyPosted: 'Last reply posted',
    kEnterEventNameOrEventCode: 'Enter Event Name or Event Code',
    kRateNow: 'Rate Now',
    kSelectFile: 'Select File',
    kCongratulations: 'Congratulations',
    kCongratulationsAllset: "Congratulations! You're all set for",
    kWaitingForConnection: 'Waiting for connection request confirmation',
    kCongratulationsMemberEvent:
      'Congratulate the most active members of our event',
    kNotSpecified: 'Not Specified!!!',
    kYou: 'You',
    kOf: 'of',
    kOk: 'Ok',
    kThankYou: 'Thank you!',
    KFinish: 'Finish',
    kEdit: 'Edit',
    kInvite: 'INVITE',
    kChatRequest: 'Chat Request',
    kChallengeCompleted: 'Challenge Completed',
    kGetConnectionForBlock:
      'You need to be connected to the Internet for blocking.',
    kClearChat: 'Clear Chat',
    kBlockUserTxt: 'Block  User',
    kAddToMyAgenda: 'Add to My Agenda',
    kUnblockUserTxt: 'Unblock  User',
    kLoginFailed: 'Login Failed',
    kSuggested: 'Suggested',
    kPasscodeExpired: 'Passcode expired',
    kQRCodeInvalid: 'QR code is invalid!',
    kQRCodeExpired: 'QR code expired',
    kInterests: 'Interests',

    kOptional: 'Optional',
    KToText: 'To',
    kNeedPermissions: 'Need Permissions',
    kNeedPermissionGrandFromSettings:
      'This app needs permission to use this feature. You can grant them in app settings',
    kPeopleWhoLikePost: 'People who liked this post',
    kFeedWillAppearSoonMsg:
      'Feeds will appear here as soon as they publish. Check Back Later',
    kTryOtherOption: 'Please try with other options',
    kTryAgainLater: 'Please try again later',
    kCreatePostWithInApp: 'Create a new post(within the app only)',
    kWantsToConnect: 'Wants to connect with you',
    kChooseInterest: 'Choose your interests(optional)',
    PointCameraAtQRCodeToScan: 'Point camera at a QR Code to Scan',
    kSearchAnotherKeyword: 'Please try to search with another keyword.',
    kWillAppearSoonMsg:
      'will appear as soon as it is bookmarked. Please check back later.',
    kAvailableInSessionStarts:
      'Please wait. It will be available once the session starts',
    kStartConversationMsg:
      'No messages. To start a conversation say something...',
    kWantToSkipTypingMsg:
      'Want to skip the typing? We can email you a magic link that will instantly sign you in.',
    kTellUsSomethingAboutYourself:
      'Tell us something about yourself (Optional)',
    kWillAppearSoonTheyPublished:
      'will appear here as soon as they are published. Please check back later',
    kWouldULikeToConnectBIFormMsg:
      'Would like to connect with you on Business Innovation forum?',
    kEnableToShareProfileMsg:
      'This will enable you to share your profile and connect with other users',
    kPubliclyVisibleUserDetailsMsg:
      'The user details mentioned below will be visible publicly',
    kQRShowingMsg:
      'By showing the QR I allow my profile and email to be shared',
    kSendYouEmailMsg: "We'll send you an email that will instantly sign you in",
    kLoginToAccount: 'Login to your account',
    kWriteSomething: 'Write something...',
    kFullName: 'FULL NAME :',
    kEnterFullName: 'Enter full name',
    kNoResultsFound: 'No Results Found',
    kQRScanner: 'QR Scanner',
    kGoToSettings: 'Go to settings',
    kShareUsing: 'Share Using',
    kSearchByNameOrEmail: 'Search by name or email',
    kPlsTryAgainQRNotValid: 'Please Try Again. QR is not valid',
    kBrowseCountry: 'Browse by Country',
    kAnotherKeywordSearch: 'Please try again with another keyword',
    kSearchThisEvent: 'Search this event...',
    kNoDataFound: 'No Data Found!',
    kEventName: 'Event Name',
    kViewOnMap: 'View on Map',
    KViewFullProfile: 'View Full Profile',
    kFilter: 'Filter',
    kEXIT: 'EXIT',
    kNetworking: 'Networking',
    kNetworkingIsOn: 'Networking is On',
    kNetworkingIsOff: 'Networking is Off',
    kNetworkingSwitching: 'Please wait... Switching',
    kNetworkingInvitations: 'Networking invitations',
    kHidePost: 'Hide Post',
    kReportPost: 'Report Post',
    kShowAll: 'Show All',
    kApply: 'Apply',
    kSearchInterests: 'Search by interests',
    kMyQrCode: 'My Qr Code',
    kORTxt: 'OR',
    kWhich: 'Which',
    kTrySearching: 'Try searching',
    kNoScansFound: 'No Scans Found',
    kVenueMaps: 'Venue maps',
    kNewContact: 'New Contact',
    kWouldYouLikeToJoin: 'Would you like to join?',
    kGetMagicLink: 'Get a magic link',
    kYourEmailAddress: 'Your Email Address',
    kYourEmailAddressFor: 'Your email address for',
    kAbout: 'About',
    KEditAbout: 'Edit About',
    KeditOpertingCountry: 'Edit Operating Country',
    KselectOperatingCountry: 'Select Operating Countries',
    kSkip: 'Skip',
    kBio: 'Bio :',
    kContactAdmin: 'Contact Admin',
    kStartNetworking: 'Start Networking',
    kYouHaveAlreadyRated: 'You have already rate this session',
    kRatingSuccess: 'Your rating submitted successfully',
    kWaitingForAdminToLogIn: 'Waiting for admin to log you in',
    kCloseThisScreen: '(Please do not close this screen)',
    kLoginAndCompleteProfile:
      'Login & complete your profile to connect and start networking with people',
    kTurnOnNetworking: 'Turn On Networking',
    kSignInManually: 'Sign in manually',
    kNeedAlternateLogin: 'Need Alternate Login?',
    kNoEventsFound: 'No events found',
    kSorryNoEventsFound: 'Sorry! No Events Found',
    kSearchEventName: 'Search by event name or event code',
    kNoPostYet: 'No posts yet!',
    kAddFirstPost: 'No posts yet!  Be the first to add a post...',
    kSearchWithAnotherKeyword:
      'Please try again searching with another keyword',
    kAddCaption: 'Add a caption',
    kNewMessage: 'New Message',
    kLoginUsingEmail: 'Login Using Email',
    kAllowAndShowQR: 'Allow and Show QR',
    kDontShowQR: "Don't Show QR",
    kMyQR: 'MY QR',
    kFiles: 'Files',
    kUnfollow: 'Unfollow',
    kChat: 'Chat',
    kWantToLeave: 'Are you sure you want to Leave?',
    kUploading: 'Uploading...',
    kYesterdayAt: 'Yesterday at',
    kVotes: 'votes',
    kLastPosted: 'Last posted',
    kCommentReported: 'Comment Reported',
    kPlsWaitWhileExporting: 'Please wait while exporting..',
    kPlsWaitWhileExportingContacts: 'Please wait while exporting contacts..',
    ErrorMessages: '',
    kNoInternet: 'No Internet Connection',
    kNoInternetMsg: 'You need internet connection to proceed!',
    kValidationError: 'Validation Error',
    kSomethingWrong: 'Snap! Something went wrong!',
    kCheckOutUser: 'Are you sure you want to check this user out?',
    kSwitchEventConfirm: 'Are you sure you want to switch the event?',
    kAlreadyLoggedIn:
      'You are already logged in by other device. Please Logout.',
    kLogoutOther: 'Do you want to logout from other device and continue login?',
    kLeaveEvent: 'Are you sure you want to leave this event?',
    kSyncEvent: 'Are you sure you want to sync the event?',
    Onboarding: '',
    KFromText: 'From',
    kEmailNotRegistered:
      'You are not registered for this event. Please contact event organizers',
    kUserNotFound: 'User not found',
    kSendEmail: 'Send Email',
    kInActiveUser: 'User disabled',
    kDoYouWantReportPost: 'Do you want to report this post?',
    kInActiveUserMsg:
      'Your login has been disabled. Please contact event organiser.',
    kWaitListMode:
      'You are not registered for this event. Please contact event organiser.',
    kCreateANewPostMsg:
      'Create a new post or feeds will appear here as soon as others publish any post. Please check back later.',
    KNoMeetingsInvite:
      'It appears that you do not have an invitation. Please arrange your schedule to enable others to join you in the meeting.',
    KMeetingSetting: 'Meeting Settings',
    KMeetingTitle: 'Meeting Title',
    KWriteMeetingTitle: 'Write a meeting title',
    kWriteLocationAndLink: 'Write meeting location or link',
    KMyMeetings: 'My Meetings',
    KMeetingOverlapError:
      'Your meeting schedule cannot overlap with other meeting!',
    KEndTimeError: 'End time cannot be less than start time!',
    KAvailableDates: 'Available Dates',
    KMeetingLocationAndLink: 'Meeting Location or Link',
    KMeetingDetails: 'Meeting Details',
    KAvailableMutualTime: 'Available Mutual Time',
    KShowMyAvailabilityOnly: 'Show my availability only',
    KScheduleMeeting: 'Schedule a Meeting',
    KRescheduleMeeting: 'Reschedule Meeting',
    KCancleMeeting: 'Cancle Meeting',
    KOneonOne: 'One-On-One',
    KMeetingWith: 'Meeting with',
    KOneOnOneMeeting: 'One-on-One Meeting with',
    KMeetingConfirmation: 'Meeting Confirmation',
    KMeetingConfirmedText: 'Meeting Confirmed',
    KMeetindScheduleandConfirm: 'Meeting is scheduled and confirmed.',
    KYouWillBeNotified: 'You will be notified once confirmed.',
    KMeetingDateTimeOver: 'meeting date/time is over.',
    KMeetingRequestSent: 'Meeting Request Sent',
    KMeetingConfirmAutomatically: 'Meetings will be confirmed automatically.',
    KMeetingDuration: 'Meeting Duration',
    KMeetingTimeSlotDuration: 'Time-slot duration of your meetings.',
    KScheduleTime: 'Schedule Time',
    KAvailableMeetingSlot: 'Set your availability window.',
    KEditMeeting: ' Edit Meeting',
    KMeetingAvailability: 'Meeting Availability',
    KAttendingScheduleMeeting: 'Attendees can schedule a meeting',
    KAcceptMeeting: 'Accept Meeting',
    KInvitee: 'Invitee',
    KNoMeetingInviteText: 'No Meetings Invite',
    kWaiting: 'Waiting',
    kSkipThisVersion: 'Skip this Version',
    kUpdate: 'Update',
    kUpcomingEvents: 'Upcoming Events',
    kPastEvents: 'Past Events',
    kTryAgain: 'Try Again',
    kSettings: 'Settings',
    kEmailUsAt: 'Email us at',
    kEnterOTP: 'Enter OTP',
    kEnterPassword: 'Enter Password',
    kYourPasswordFor: 'Your password for',
    kProblemLoginIn: 'Problem logging in?',
    kClickHereTo: 'Click here to',
    kContactSupport: 'contact support',
    kUnknownErrorOccurred: 'Unknown error occurred',
    kContactSupportBtn: 'Contact Support',
    kCopiedToClipboard: 'Copied to clipboard',
    kEmailCopiedToCboard: 'Email copied to clipboard',
    kYesIConfirm: 'I confirm',
    kLogoutText: 'Logout',
    kConfirm: 'Confirm',
    KValidity: 'Validity',
    KcouponURL: 'Coupon URL',
    kValidityExpireTitle: 'The event is now over. Thank you for attending!',
    kValidityExpireMessage:
      'The event has concluded. For more information, please contact the event organizers.',
    Notifications: '',
    kThankYouSubscribe:
      'Thank you for subscribing. You will now receive notifications for all activities.',
    Social: '',
    kReportCommentMsg: 'Do you want to report this comment?',
    kReportComment: 'Report comment',
    kReportText: 'Report',
    kDeletePost: 'Delete post',
    kDeleteConfirm: 'Do you want to delete this post?',
    kDeleteText: 'Delete',
    kCopyText: 'Copy',
    kDeleteComment: 'Delete comment',
    kDeleteCommentConfirm: 'Do you want to delete this comment?',
    kErrorCharacterLimit: 'You have exceeded the character limit',
    kLike: 'Reaction',
    kLikes: 'Reactions',
    kComment: 'Comment',
    kComments: 'Comments',
    kAddPostContent: 'Please add some content to your post',
    kPostReported:
      'This post has been reported and action will be taken by admin.',
    kPostDeleted: 'This post has been deleted.',
    kPostCreated: 'Post created successfully.',
    kCommentDeleted: 'This comment has been deleted.',
    Schedule: '',
    kGoToMap: 'Go to Map',
    kChange: 'Change',
    kRemoveFromAgenda: 'Remove from Agenda',
    kRemindOneHour: 'You will be reminded 1 hour before the session.',
    kRemindOneDay: 'You will be reminded 1 day before the session.',
    kRemindOn: 'You will be reminded on',
    kBeforeSession: 'before the session.',
    kAt: 'at',
    kSessionSpeakerText: 'Session Speakers',
    kLiveSessionText: 'Live Session',
    kWatchLiveSessionText: 'Watch Live Session',
    kWatchVideoConferenceText: 'Watch Video Conference',
    kSessionFilesText: 'Session Files',
    kSessionTagsText: 'Session Tags',
    kTagText: 'Tag',
    kSaveSession: 'Save Session',
    kSaveToCalendar: 'Save To Calendar',
    kUpgradePremium: 'Upgrade to Premium to view this session.',
    kSessionFull: 'Session capacity is full.',
    kSessionNotFoundSyncApp: 'Session not found. Please sync app',
    kSessionNotStarted: 'Session has not started yet',
    KLoadingMeetingSlots: 'Loading Meeting Slots Please wait...',
    KDataBeingFetched: '',
    kSessionWait: 'Please wait. It will be available once session started.',
    kEventAdded: 'Event successfully updated to your calendar',
    kAlreadyRated: 'You already gave rating for this session',
    kRateAfter: 'You can rate after the session is completed',
    kSessionConfirm: 'Please confirm if you are attending this session.',
    kCancelRSVP: 'Are you sure you want to cancel your RSVP?',
    kAddToCalendar:
      'Are you sure you want to add this session to your local calendar?',
    kMsgCheckedInSession:
      'Thank you! You are successfully checked in for this session',
    kMsgScanToCheckin: 'Scan QR to checkin user',
    kMsgShowQRToScan:
      'To check-in for the session please show the Session QR to scan',
    kSessionScanning: 'Session Scanning',
    kCancelRSVPTitle: 'Cancel my RSVP',
    kLiveQAText: 'Live QA',
    kPollsText: 'Polls',
    kEmptyLiveQAText: 'View QA here LIVE as they are posted by you or others',
    kQADisbaledText: 'Q&A is disabled by admin',
    kEmptyPollsText:
      'Polls will appear as soon as they are created. Please check back later.',
    kMutualInterests: 'Mutual Interests',
    'Survey and Polls': '',
    kSurveyResponded: 'You have already responded to this survey!',
    kPollOptionsError: 'Poll post should have atleast 2 options',
    kAttachementError: 'You can add maximum 10 attachments',
    kOptionsError: 'You can add maximum 4 options',
    kQuestionPosted:
      'Your question is posted successfully and is under review by event admin',
    kEnterQuestion: 'Please enter question!',
    kEnterOptions: 'Please enter option!',
    kAlreadyVoted: 'You have already voted for this poll!',
    kNoSessions: 'No sessions are available!',
    kSelectOption: 'Please select an option before submitting!',
    kUnpublish: 'Are you sure you want to unpublish?',
    kPublish: 'Are you sure you want to publish?',
    Chat: '',
    kRescheduleText: 'Re-Schedule',
    kMeetingExpiredText: 'Meeting Expired',
    kMeetingCancelledText: 'Meeting Cancelled',
    kMeetingAcceptedText: 'Meeting Accepted',
    kBlockedByMe: 'You have blocked this user. Unblock?',
    kBlockedByOther: 'You have been blocked by this user',
    kUserBlocked: 'User blocked',
    kCancelInvite: 'Do you want to Cancel Invitation?',
    kDeleteChat: 'Do you want to clear the chat messages?',
    kRemoveUser: 'Are you sure want to remove this user?',
    kBlockUser: 'Do you want to block this user?',
    kUnblockUser: 'Do you want to unblock this user?',
    kStartVideoMeet: 'Do you want to start a video meeting?',
    kCancelMeet: 'Do you want to cancel this meeting?',
    'Exhibitor/Sponsor': '',
    kVcardAlreadyDropped: 'You have already shared vCard to us',
    kVcardShared: 'vCard dropped successfully',
    kCheckYourInbox: 'Check your inbox',
    kOpenEmailApp: 'Open Email App',
    kHaveGotANewMail: 'You have got a new mail',
    kSendYouAnEmailMsg: "We've sent you an email",
    kViewAllText: 'View All',
    kAddNotesText: 'Add Note',
    kBrowseByText: 'Browse By',
    kValidUntil: 'Valid until',
    kSearchText: 'Search',
    kInvited: 'Invited',
    kSearchByText: 'Search by',
    kSendVcardTo: 'Send vCard to',
    kEmailClick: 'Email Click',
    kMessagesText: 'Messages',
    Notes: '',
    kAddNoteToSave: 'Please add a note to save.',
    kYouHavePasscode: 'Do you have the passcode?',
    kNoteAdded: 'Your note has been successfully added',
    kNoteUpdated: 'Your note has been successfully updated',
    kNoteDeleted: 'Your note has been successfully deleted',
    Permissions: '',
    kPhotoAccessTitle: 'Allow photo album access?',
    kPhotoPermission: 'Need your permission to access photo album',
    kCameraPermission:
      'Please grant camera Permissions from Settings > Privacy > Camera',
    kAllowLocationTitle: 'Allow Location Access?',
    kAllowLocationDescription:
      'Allowing us to use your current location will enable us to show you your location based event details.',
    kCameraPermissionText: 'Need your permission to take a photo',
    'QR-Scan': '',
    kNoScanFound: 'No Scan(s) Found',
    kUserQRScanner: 'Use the QR scanner to scan contact when presented.',
    kStopQR:
      "You have stopped sharing your QR. Previous sharing doesn't affect after turning off.",
    kCancelAddScan:
      "Are you sure you don't want to add this user to your contact?",
    kMsgScanToConnect: 'Scan QR to connect',
    kMyQRScans: 'My QR Scans',
    kMyVcards: 'My Exhibitor vCard Drops',
    Miscellaneous: '',
    kDelete: 'Are you sure you want to delete?',
    kActivityReported:
      'This activity has been reported and action will be taken by admin.',
    kEnterMessage: 'Please enter your message',
    kSelectOneUser: 'Please select atleast one user',
    kSelectOneFile: 'Please select atleast one file',
    kNotificationSent: 'Notification sent successfully',
    kInvalidEmail: 'Email is invalid!',
    kShareEmail: 'Please share your email while signin to join the event.',
    kPasscodeRequired: 'Passcode Required.',
    kEnterPasscode: 'Please enter passcode.',
    kInvalidPasscode: 'Passcode is invalid',
    kOTPSent: 'A 6 digit OTP has been sent to your email.',
    kNameRequired: 'Name Required',
    kEnterName: 'Please enter your name.',
    kEnterFirstName: 'Please enter your Firstname!',
    kEnterLastName: 'Please enter your Lastname!',
    kEnterMandatory: 'Please fill all mandatory fields!',
    kProfileUpdated: 'Your profile is updated successfully.',
    kNoFilter: 'No filter applied!',
    kFilterbyMember: 'Filter Leads by Team Members',
    kOtherFilter: 'Other filters',
    kContactAdded: 'Contact added Successfully!',
    kContactsEmailed: 'Contacts have been emailed to you!',
    kUserUnavailable: 'User is not available for networking',
    kFieldRequired: 'This field is required!',
    kImageUploaded: 'Image uploaded Successfully!',
    kFrameUploaded: 'Frame set Successfully!',
    kUploadFailed: 'Failed to upload image!',
    kVideoUploaded: 'Video uploaded Successfully!',
    kAudioUploaded: 'Audio uploaded Successfully!',
    kVideoFailed: 'Failed to upload video!',
    kRecipientNotFound: 'Recipient email not found',
    kDeleteProfile: 'Are you sure you want to delete your Profile?',
    kLogoutConfirm: 'Are you sure you want to logout?',
    kCreatingProfile:
      'By Creating Profile you are allowing your information to be visible to other users.',
    kRemoveVideo: 'Are you sure want to remove this video?',
    kRemoveImage: 'Are you sure want to remove this image?',
    kCancel: 'Cancel',
    kChooseMedia: 'Choose Media',
    kCaptureMedia: 'Capture Media',
    kReadMore: 'Read More',
    kReadLess: 'Read Less',
    kYesText: 'YES',
    kNoText: 'NO',
    kSendInMail: 'Send in Email',
    kSaveToDevice: 'Save to device',
    kLiveText: 'LIVE',
    kOnlyAdminPostText: 'Only admin can post in this group',
    kAdditionalDetails: 'Additional Details',
    kLeaveCommunityText: 'Are you sure you want to leave this community?',
    kFillPasscodeToLoginMsg:
      'Input the passcode you received in your email to continue with login',
    kUserDetailMentionedMsg:
      'The user details mentioned below will be visible only on consent.',
    kInformationText: 'Information',
    kSelectPlaceholder: 'Select an option',
    kSelectDatePlaceholder: 'Select a date',
    kEmptyRatingComment: 'Please select at least one option',
    kRatingPlaceholder: 'Please enter',
    kCheckInText: 'Check-in',
    kScanQRText: 'Scan QR',
    kViewQRText: 'View QR',
    kEmptySetPlaceholder: 'will appear as soon as they are created.',
    kEmptySetAddedPlaceholder: 'will appear here as soon as they are added.',
    kCheckBackLater: 'Please check back later.',
    kContinueText: 'Continue',
    kPastTimeErr: 'Please select future time',
    kHelpSupportText: 'Help & Support',
    KaddMoreText: 'Add More',
    KuploadFiles: 'Upload Files',
    kEmptyConversation: 'No Conversation!',
    kEmptySupportMessages:
      'Messages will appear once they are sent from users.',
    kSupportChatTitle: 'Questions? Chat with us!',
    kEmptySupportChat: 'Have Questions?',
    kEmptySupportChatDesc: 'Start a conversation with us',
    kSupportEnterEmail: 'Please enter a valid email address.',
    kSupportMessageEmail:
      'Please share your registered email ID. Our organizers will get back to you as early as possible.',
    kNoCommentTitle: 'No comment Available',
    kNoCommentTextDesc: 'No Comment! Be the first one to comment',
    kCancelRequestText: 'Cancel Request',
    kRequestToJoinText: 'Request to Join',
    kCancellingText: 'Cancelling...',
    kRequestingText: 'Requesting...',
    kEmptyCommunityTitle: 'Be the first to add a post',
    kEmptyCoversationTitle: 'Be the first to start a conversation',
    kReportAsInappropriate: 'Report as inappropriate',
    KembedfromURL: 'Embed Video from URL',
    KVideoSource: 'Video Source',
    KenterVideoURl: 'Enter Video URL',
    KselectIndustry: 'Select Industries',
    KhostDemo: 'Host Product Demo',
    KeditIndustry: 'Edit Industry',
    kFollowingText: 'Following',
    kFollowText: 'Follow',
    kPostText: 'Post',
    kPostsText: 'Posts',
    kReplyText: 'Reply',
    kReportedSuccess: 'Reported Successfully',
    kRepliesText: 'Replies',
    kMemberText: 'Member',
    kMembersText: 'Members',
    kSeePassword: 'See Password',
    kAllowAccess: 'Allow Access',
    kHeyThere: 'Hey There!',
    kTapToLogin: 'TAP TO LOGIN',
    kQuestionsText: 'Questions',
    kReadAllText: 'Read All',
    kSaveText: 'SAVE',
    kExportText: 'Export',
    kMyScansText: 'My Scans',
    kConnectingText: 'Connecting...',
    kRSVPText: 'RSVP',
    kCapacityText: 'Capacity',
    kNotificationsText: 'Notifications',
    kBookmarksText: 'Bookmarks',
    kBookmarkText: 'Bookmark',
    kBookmarkedText: 'Bookmarked',
    kNotesText: 'Notes',
    kContactSavedText: 'Contact Saved successfully!',
    kCharactersLeft: 'characters left',
    kAllSessionAttendee: 'All Session Attendees',
    kAddedOn: 'Added On',
    kSwitchEvents: 'Switch Event',
    kAdminTools: 'Admin Tools',
    kEmptyPostText:
      'Create a new post or feeds will come here as soon as others will publish. Check Back Later',
    kNoPostText: 'No post Available',
    kYesGotIt: 'Yes. Got it',
    kNotNow: 'Not now',
    kYouHaveGot: 'You have got',
    kWriteAComment: 'Write a comment on a social post',
    kPointsCapText: 'Points',
    kPointsText: 'points',
    kSaveSettings: 'Save Settings',
    kPointCapText: 'Point',
    kPointText: 'point',
    kViewsText: 'Views',
    kSendvCardNow: 'Send vCard Now',
    kMyScansTitleText: 'My Scans',
    kContactsFound: 'Contacts Found',
    kContactFound: 'Contact Found',
    kCopyCode: 'Copy Code',
    kPhotos: 'Photos',
    kNoUserFound: 'No user(s) Found',
    kTryDifferentTag: 'Please try again using different tags.',
    kNoAttendeesFound: 'No attendee(s) found',
    kDeclineText: 'Decline',
    kAcceptText: 'Accept',
    kCreateProfile: 'Create Profile',
    kAcceptingText: 'Accepting...',
    kViewText: 'View',
    kFeaturedText: 'Featured',
    kSendAMessage: 'Sent a message.',
    kSuggestedContactsText: 'Suggested Contacts',
    kSentMeetingRequest: 'has sent you a meeting request.',
    kThisSessionIsOn: 'This session is on',
    kAsPerYourTimeZone: 'as per your local timezone',
    kNoTextLC: 'No',
    kFoundText: 'Found',
    kSelectSession: 'Select session for scan',
    kAttendeeText: 'Attendee',
    kAttendeesText: 'Attendees',
    kEmptyAttendeeCheckIn: 'No Attendee(s) checked in yet',
    kEmptyCheckInDescription: 'Use the QR scanner to check-in atteendee(s).',
    kSelectSessionAndText: 'Select session and',
    kQRCodeText: 'QR Code',
    kSessionQRCodeText: 'Session QR Code',
    kSessionDetailsText: 'Session Details',
    kFeatureUnavailableText: 'This feature is not available',
    kCommunityText: 'Community',
    kSpeakerText: 'Speaker',
    kSessionText: 'Session',
    kLinkText: 'Link',
    kExhibitorText: 'Exhibitor',
    kSponsorText: 'Sponsor',
    kPollText: 'Poll',
    kNotificationDetailsText: 'Notification Details',
    kNewsText: 'News',
    kExhibitorDeleted: 'This exhibitor is deleted',
    kSponsorDeleted: 'This sponsor is deleted',
    kSpeakerDeleted: 'This speaker is deleted',
    kPollDeleted: 'This poll is deleted',
    kCommunityDeleted: 'This community post is deleted',
    kSocialDeleted: 'This social post is deleted',
    kNewsDeleted: 'This news is deleted',
    kSessionDeleted: 'This session is deleted',
    kLoginText: 'Login',
    kViewMoreText: 'View More',
    kSurveyResponseText: 'We have received your response!',
    kSurveyDoneText: 'You have already done this survey',
    kSurveyNotFoundText: 'Survey not found. Please contact organizer.',
    kThankYouText: 'Thank You',
    kSurveyText: 'Survey',
    kMapLinkedWith: 'Map Linked with',
    kJustWriteAComment: 'Write a comment',
    kAskAQuestion: 'Ask a question',
    kManageText: 'Manage',
    kLeaveDiscussion: 'Leave Discussion',
    kViewOnText: 'View on',
    kTotalVotesText: 'Total Votes',
    kVoteText: 'vote',
    kCopytextText: 'Copy text',
    kUnpublishedText: 'Unpublished',
    kPublishedText: 'Published',
    kLiveQnAText: 'Live Q&A',
    kWatchLiveText: 'Watch Live',
    kActivePollsText: 'Active Polls',
    kArchivedPollsText: 'Archived Polls',
    kLiveNowText: 'LIVE NOW',
    kMyAgendaText: 'My Agenda',
    kMakeAPostText: 'Make a post',
    kTakeANoteText: 'Take a Note',
    kScanAQRText: 'Scan a QR',
    KScanResultText: 'Scan Result',
    kQuickLinksText: 'Quick Links',
    kConnectPeopleText: 'Connect and start networking\nwith people',
    kChallengesCompletedText: 'challenges completed',
    kChallengeProgressText: 'Challenge Progress',
    kGetExcitingRewardsText: 'Get Exciting Rewards',
    kNewsUpdateText: 'News Update',
    kScheduleMeetingText: 'Schedule Meeting',
    kRescheduleMeetingText: 'Reschedule Meeting',
    kGDPRConsentText:
      'Networking/GDPR Consent (This will enable to share your profile with other users.)',
    kTurnedOffConsentText: 'has turned off the Networking/GDPR consent',
    kGDPRConsentTitleText: 'Networking & GDPR Consent',
    KGDRPConsentDescription:
      'By proceeding, you acknowledge and agree that your profile information will be shared with other attendees of this event.',
    kGDPRNoteText: 'You can always turn this on/off from your profile section.',
    kTurnOnNetworkingText: 'Please Turn On Networking / GDPR Consent',
    kPollResultText: 'Poll Result',
    kDoneText: 'Done',
    kHomeText: 'Home',
    kSessionReminderText: 'Session Reminder',
    kReminderSubText: 'Would you like to add a reminder for this session?',
    kBefore1DayText: 'Before 1 day',
    kBefore1HourText: 'Before 1 hour',
    kSetATimeText: 'Set a time',
    kNoReminderText: 'No Reminder',
    kSetReminderText: 'Set Reminder',
    kAutoPublishText: 'Auto Publish',
    kAnswerSubmittedText: 'Your answer has been successfully submitted',
    kSayHelloText: '👋 Say Hello',
    kYouAreConnectedText: 'You are connected',
    kRejectText: 'Reject',
    kUnblockText: 'Unblock',
    kInviteText: 'Invite',
    kSentText: 'Sent',
    kEditNoteText: 'Edit Note',
    kSaveNoteText: 'Save Note',
    kWriteSomethingText: 'Write something here...',
    kMeetingRequestText: 'Meeting Request',
    kRateThisSessionText: 'Rate',
    kOverviewText: 'Overview',
    kOTPSentAndEnter:
      'A 6 digit OTP has been sent to your email. Please enter OTP below.',
    kResendOTPText: 'Resend OTP',
    kNextText: 'Next',
    kProfileText: 'Profile',
    kAllowNotificationsText: 'Allow Notifications?',
    kNotificationsDescText:
      'Turning on notifications lets us send you customized alerts and personalized recommendations.',
    kNotifyMeText: 'Notify me',
    kBoothText: 'Booth',
    kBoothPersonnelText: 'Booth Personnel',
    kStatsText: 'Stats',
    kProductCategoryText: 'Product Category',
    kNotificationSettings:
      'You can enable notifications  from Settings > Eventify > Notifications > Allow Notifications',
    kEnableNotificationsText: 'Enable Notifications',
    kDetailsText: 'Details',
    kNewsDetailsText: 'News Details',
    kCreatePostText: 'Create Post',
    kPostPlaceholderText: 'What would you like to post about?',
    kRecordText: 'Record',
    kChooseFromGalleryText: 'Choose from Gallery',
    kActiveText: 'Active',
    kArchiveText: 'Archive',
    kEnterPollTitleText: 'Enter poll title',
    kWriteAndPostText: 'Write and post something',
    kWarningText: 'Warning',
    kAttachmentLostText: 'Your attachments will be lost',
    kDiscardText: 'Discard',
    kPollLostText: 'Your poll options will be lost.',
    kEnterOptionText: 'Enter option',
    kAddNewOptionText: 'Add New Option',
    kEnterPasscodeText: 'Enter Passcode',
    kVoteNowText: 'Vote Now',
    kVotedText: 'Voted',
    kMeetingEndedText: 'Your meeting has ended',
    kScreenControlText: 'Switch to full screen for controls',
    kRejoinNowText: 'Rejoin now',
    kRateSessionText: 'Please Rate the Session',
    kSayHiText: '👋 Say Hi',
    kSubmitText: 'Submit',
    kQuestionText: 'Question',
    kPleaseSelectAnswerText: 'Please select your answer',
    kSelectMultipleOptionText: 'You can select multiple options',
    kAddQuestionText: 'Add Question',
    kAsText: 'As',
    kFilterByInterestsText: 'Filter by interests',
    kErrorText: 'Error',
    kFilterByGroupText: 'Filter by user group',
    kNoAttendeeForEventText: 'No attendee for the event',
    kNoAttendeeDescriptionText:
      'There is no attendee for the event yet. Please come back later.',
    kChooseASessionText: 'Choose a session',
    kEmailText: 'Email',
    kEnterRegistrationEmail:
      'Enter the email address you provided during event registration.',
    kNotificationAccessTitle: 'Would Like to Send You Notifications',
    kNotificationAccessSubtitle:
      'Notifications may include schedule reminders messages sponsored ads etc. These can be configured in Settings.',
    kAllowText: 'Allow',
    kDenyText: 'Deny',
    kPromoteYourselfText: 'Promote Yourself',
    kFiltersText: 'Filters',
    kResetAllText: 'Reset All',
    kIndustryText: 'Industry',
    kCategoryText: 'Category',
    kCountryText: 'Country',
    kApplyText: 'Apply',
    kCalendarAccessTitle: 'Would Like to Access Your Calendar',
    kCalendarAccessSubtitle:
      'Calendar permission is required to import/export schedules/meetings to your calendar.',
    kCameraAccessTitle: 'Would Like to Access the Camera',
    kCameraAccessSubtitle:
      'Camera access is required to scan QR codes and check in.',
    kGalleryAccessTitle: 'Would Like to Access the Photo Gallery',
    kGalleryAccessSubtitle:
      'Allow access to the photo library so you can upload photos to',
    kUpdateCalendar: 'Update to Calendar',
    kUnpin: 'Unpin',
    kPin: 'Pin',
    kCheckedIn: 'Checked in',
    kCheckIn: 'Check in',
    kNoteDetails: 'Note Details',
    kNewNote: 'New Note',
    kUpdateSession: 'Update Session',
    kValidHours: 'Valid for 24 hours',
    kUnblocked: 'Unblocked',
    kRemoveSponsor: 'Remove Sponsor',
    kSaveSponsor: 'Save Sponsor',
    kFacebookLink: 'Facebook Link',
    kVisitFb: 'Visit Facebook',
    kVisitTwitter: 'Visit Twitter',
    kVisitLinkedIn: 'Visit LinkedIn',
    kLinkedInLink: 'LinkedIn Link',
    kWebLink: 'Web Link',
    kCall: 'Call',
    KAppText: 'app',
    kCopyNumber: 'Copy Number',
    kPhoneNumber: 'Phone Number',
    kCopyFbLink: 'Copy FB Link',
    kCopyLinkedInLink: 'Copy LinkedIn',
    kCopyTwitterLink: 'Copy Twitter Link',
    kTwitterLink: 'Twitter Link',
    KSelectedText: 'Selected',
    kGmailAppNotInstalled: 'Gmail App is not installed in your device',
    kNoSessionsSelected: 'No session is selected',
    kNoteShouldNotBlank: 'Note should not be blank',
    kCould_not_add_user: 'Could not add user. Please try again!',
    kInvalidTimeZoneTxt: 'Your timezone is not valid',
    KTimeZoneText: 'TimeZone',
    KMyTimeZone: 'Times are in my timezone',
    kLiveStreamingAvailableMsg: 'Live streaming is available now',
    kCreatePostTxt: 'Write something or add some attachments',
    kLiveSessionAvailableMsg: 'Live streaming will be available soon',
    kAllowPermissions: 'You need to allow access to the permissions',
    kAllowLocationPermissions:
      'You need to allow the Location permission to access location',
    kErrorInAddingNotes: 'Error while adding notes. Please try again...',
    kWant_to_update_local_calendar:
      'Are you sure you want to update this session to your local calendar?',
    kSessionNotBookmarked:
      'You can build your personal agenda by bookmarking any session from the schedule',
    kqr_code_turnoff_warning:
      "You have stopped sharing your QR previous sharing doesn't affect after turning off",
    kEnterAnyKeywordText: 'Enter any keyword to search',
    kClearText: 'Clear',
    kAddPollText: 'Add poll',
    kPromoteYourSession: 'Promote Your Session',
    kSpeakerBannerNotice:
      'Increase your session engagement by promoting and sharing personalised banner on social media.',
    kSelectASession: 'Select a Session',
    kSortByNew: 'Sort by new',
    kDateText: 'Date',
    kTimeText: 'Time',
    kGamificationsText: 'Gamifications',
    kCameraAccessNormalSubtitle: 'Camera access is required to click photos.',
    kErrorTerms: 'Please accept the Terms & Conditions',
    kPleaseAcceptThe: 'Please accept the ',
    kTermsAndConditions: 'Terms & Conditions',
    kKioskDescription:
      'Attendee database not found. It is recommended to download before start.',
    kAttendeeLastSync: 'Attendee database was last synced on',
    kDownloadAttendee: 'Download attendee database',
    kDownloadText: 'Download',
    kModelText: 'Model',
    kIPAddressText: 'IP Address',
    kClosingInText: 'Closing in',
    kCheckOutText: 'Check out',
    kUnableToOpen: 'Unable to open channel. Open stream failure',
    kErrorPrinting: 'Error while printing badge. Please try again.',
    kBadgePrintSuccess: 'Badge printed successfully.',
    kEditProfileText: 'EDIT PROFILE',
    kNoReportedPost: 'No reported post Available',
    kJoinRequests: 'Join Requests',
    KTitle: 'Title',
    KdescriptionText: 'Decription',
    KproductUrl: 'Product URL',
    Kpreffered300size: '300 X 300 px preferred',
    KProductTitle: 'Product Title',
    KAddProduct: 'Add a Product',
    KAddPhotosText: 'Add photos',
    KProductImage: 'Product Image',
    kPostTitleText: 'Post Title',
    kPostDetailsText: 'Post Details',
    kPostTitlePlaceholder: 'Give your post a nice title',
    kPostDetailsPlaceholder: 'Write about the post in details',
    kNewPostText: 'New Post',
    kScanMsgText: 'Scan this QR for session check-ins & to connect with others',
    kInboxEmpty: 'Your inbox is empty',
    kPhotoText: 'Photo',
    KAddVideosText: 'Add Videos',
    KUploadVideos: 'Upload Videos',
    kMeetingText: 'Meeting',
    kVideoMeetingText: 'Video Meeting',
    kURConnectedWith: "You're now connected with",
    kWantToConnectWithU: 'Wants to connect with you.',
    kInvitationSentText: 'Invitation sent',
    kWatchVideoText: 'Watch Video',
    kPrinterOffline: 'Printer is offline.',
    kNewMessageText: 'You have a new message',
    kIsOnText: 'is On!',
    kProfileUploaded: 'Profile picture has been uploaded successfully',
    kCompleteURProfile: 'Complete your profile!',
    kURProfileSubTitle: 'Personalize your profile with a profile picture.',
    kAddPictureText: 'Add a Picture',
    kProfilePictureUploaded:
      "Hooray! You've successfully added your profile picture",
    kPromoteSubtitle:
      'Quickly promote yourself on social media with our pre-made banners just a few clicks away.',
    kGetBannersText: 'Get Banners',
    kCommunitySubtitle: 'Become a member of our\nthriving community',
    kGotNewMessage: "You've got a new message!",
    kUnreadChatText: 'UNREAD CHAT',
    kAddInterestAndConnect:
      'Add interests to your profile and start connecting!',
    kCopyWebsiteText: 'Copy Website',
    kWebsiteText: 'Website',
    kVisitWebsiteText: 'Visit Website',
    kListText: 'List',
    kGridText: 'Grid',
    kEmptyMeetingSubtitle: 'Meeting(s) will appear once they are accepted',
    kAllText: 'All',
    KBoothAndCard: 'Booth / V-card',
    kAToZ: 'A to Z',
    kCategoriesText: 'Categories',
    kSectorsText: 'Sectors',
    kSelectText: 'Select',
    kNoDescription: 'No Description Available',
    kDropVCardText: 'Drop your vCard',
    kWriteSmallNote: 'Write a small note',
    kVCardText: 'vCard',
    kAddYouNote: 'Add your note here',
    kJustNowText: 'Just Now',
    KEventmanagerText: 'Event Manager',
    kLeaderboardText: 'Leaderboard',
    KMyLeads: 'My Leads',
    KLeadsCapText: 'LEADS',
    KLeadsText: 'Leads',
    KLeadRetrival: 'Lead Retrival',
    KAutoText: 'Auto',
    KManuallText: 'Manuall',
    KLeadCaptured: 'Leads Captured',
    KExportLeads: 'Export Leads',
    KQualifyLeads: 'QUALIFY LEADS',
    KLeadHasAdded: '  Lead has been added to your collection.',
    kChallengesText: 'Challenges',
    webview: 'Webview',
    mytickets: 'My Tickets',
    stripe: 'Stripe',
    position_label: 'Position',
    kCollectRewardsText: 'BE ACTIVE COLLECT POINTS GET REWARDS',
    kGotItText: 'Got it',
    kDashboardText: 'Dashboard',
    kWelcomeBackText: 'Welcome back!',
    kManageAttendeesText: 'Manage Attendees',
    kSessionCheckInsText: 'Session Checkins',
    kCheckInForAttendees: 'Check In for Attendees',
    kKioskModeText: 'Kiosk Mode',
    kStartQRScanText: 'Start QR Scanning',
    kAttendeeDetails: 'Attendee Details',
    kSendWelcomeEmail: 'Send Welcome Email',
    kPingStartText: 'Ping Start',
    kPingStopText: 'Ping Stop',
    kAutoPrintText: 'Auto Print',
    kSelectRollText: 'Select Roll',
    kSelectAModelText: 'Select a model',
    kSetIPAddressText: 'Set IP Address',
    kBackText: 'Back',
    kOfflineText: 'Offline',
    kAskURLike: 'What would you like to ask?',
    kAddOptions: 'Add Options',
    kAllowMultiplSelection: 'Allow attendees to select multiple options',
    kShowResultsAfterSubmission: 'Show results after submission',
    kPollPSNote: 'Polls once created cannot be edited. They can be archived',
    kMeetingsText: 'Meetings',
    kCopyEmailText: 'Copy email',
    kCopyLinkText: 'Copy link',
    kCopyWhatsappText: 'Copy Whatsapp',
    kOpenInWappText: 'Open in Whatsapp',
    kCopyInstagramText: 'Copy Instagram',
    kVisitInstagramText: 'Visit Instagram',
    kCopyVideoLinkText: 'Copy Video link',
    kSaveExhibitor: 'Save Exhibitor',
    kVideosText: 'Videos',
    kProductText: 'Product',
    kCouponText: 'Coupon',
    kDealText: 'Deal',
    kCopiedToCP: 'Code copied to clipboard',
    kSelectCategory: 'Select Category',
    kViewReward: 'View Reward',
    kCheckedText: 'Checked',
    kTwitterText: 'Twitter',
    kLinkedInText: 'LinkedIn',
    kFacebookText: 'Facebook',
    kCopyFacebook: 'Copy Facebook',
    kWhatsappText: 'Whatsapp',
    kInstagramText: 'Instagram',
    kVCardNoteText: 'vCard note',
    kOnlineText: 'Online',
    kSelectSectorText: 'Select Sector',
    kBoothNumberText: 'Booth Number',
    kSelectSubCategory: 'Select Sub-Category',
    kUnpublishText: 'Unpublish',
    kPublishText: 'Publish',
    kPostAsText: 'Post as',
    kAnonymousText: 'Anonymous',
    kNoReplyAvailable: 'No reply Available',
    kBeFirstToReply: 'No reply! Be the first one to reply',
    kTypeHereToReply: 'Type here to reply',
    kSessionsText: 'Sessions',
    kLetsMeetText: "Let's Meet",
    kSendInviteText: 'Send Invite',
    kMax50Characters: 'Max 50 characters',
    kBlockingText: 'Blocking...',
    kUnBlockingText: 'Unblocking...',
    kPrintBadge: 'Print Badge',
    kHiWhatsUp: "Hi, What's Up?",
    kCancelInvitationText: 'Cancel Invitation',
    kPostDeletedByAdminMsg:
      'This post might have been deleted or removed by admin.',
    kCommentDeletedByAdminMsg:
      'This comment might have been deleted or removed by admin.',
    kMessageDeletedByAdminMsg:
      'This message may be deleted or removed by admin.',
    kCommunityPostMsg: "{USERNAME} posted '{TITLE}' in {CATEGORYNAME}.",
    kCommunityRepliedMsg: "{USERNAME} replied '{TEXT}' in {CATEGORYNAME}.",
    kCommunityRepliedImageMsg:
      '{USERNAME} replied with an image in {CATEGORYNAME}.',
    kCommunityCommentedMsg:
      "{USERNAME} commented '{TEXT}' on a community post you are following.",
    kCommunityCommentedImageMsg:
      '{USERNAME} commented with an image on a community post you are following.',
    kCommunityPostLikedMsg: '{USERNAME} liked your post on community.',
    kCommunityPostReactedMsg: '{USERNAME} reacted on your post on community.',
    kSocialPostedMsg: '{USERNAME} posted a new post on social.',
    kSocialLikedPostMsg: '{USERNAME} liked your post on social feed.',
    kSocialPollVotedMsg: '{USERNAME} voted on your poll in social feed.',
    kSocialCommentedMsg:
      "{USERNAME} commented '{COMMENT}' on a social feed post you are following.",
    kConnectionMsg: '{USERNAME} wants to connect with you.',
    kMeetingRequestedMsg: '{USERNAME} sent a meeting request',
    kChatImageMsg: '{USERNAME} sent an image',
    kChatVideoMeetingMsg: '{USERNAME} sent a video meeting request',
    kChatMessageMsg: '{USERNAME} sent a message',
    kSupportChatMsg: 'You have received a support request.',
    kClickForMoreTxt: 'Click for More',
    kSupportChatTxt: 'Support Chat',
    kFeedLoadingTxt: 'Feed loading',
    kAttendeeNotFoundTxt: 'Oops! attendee not found',
    kMeetingDateText: 'Meeting Date',
    kMeetingTimeText: 'Meeting Time',
    kMeetingScheduledWith: 'Meeting scheduled with',
    kReminderForMeeting:
      'You and {USERNAME} will be will be reminded before meeting.',
    kLandscapeText: 'Landscape',
    kRearCameraText: 'Rear Camera',
    kAll: 'All',
    kInvitationSent: 'Invitation Sent',
    kNoteAddedSuccessfully: 'Note is added successfully',
    kUnblocking: 'UNBLOCKING...',
    kAskQuestion: 'Please ask your question.',
    kMultiLoginMsg:
      'Do you want to logout from the other device and continue login?',
    kInviting: 'INVITING..',
    kRecepientEmailNotAvailable: 'Recipient email not available',
    kTotalVotes: 'Total votes :',
    kScanAQR: 'Scan a QR',
    kMyAgenda: 'My Agenda',
    kEditProfile: 'Edit Profile',
    kViewNote: 'View Note',
    kLoading: 'Loading...',
    kLoadingFiles: 'Loading files...',
    kLoadingMap: 'Loading map, please wait...',
    kUploadedSuccessfully: 'Uploaded successfully',
    kUpdatedSuccessfully: 'Updated successfully',
    kNetworkConsentNeededTxt: 'Networking Consent is needed to Comment',
    kNoteSavedMsg: 'Note Saved successfully!',
    kPublishTxt: 'Publish',
    kActivePolls: 'Active Polls',
    kArchivedPolls: 'Archived Polls',
    kPublished: 'Published',
    kUnpublished: 'Unpublished',
    kQuestion: 'Question',
    kPermissionDenied: 'Permission Denied',
    kUnPublishTxt: 'Unpublish',
    kChallengeProgress: 'Challenge Progress',
    kMyContacts: 'My Contacts',
    kAccountValidationMsg:
      'Your account is Validating. Please try after sometimes',
    kConnectAndStartNetworking: 'Connect and start networking\nwith people',
    kEventSwitchingTxt: 'Event is switching...',
    kDashboard: 'Dashboard',
    kWelcomeBack: 'Welcome back!',
    kMakeAPost: 'Make a post',
    kExportMail: 'Export in mail',
    kDownloadNote: 'Download note',
    kSimilarInterests: 'People with similar interests',
    kManageAttendees: 'Manage Attendees',
    kCheckinMangeAttende: 'Check In, Manage Attendees',
    kTakeANote: 'Take a Note',
    kSessionCheckins: 'Session Checkins',
    kRetry: 'Retry',
    kYouAnd: 'You and',
    kWillAlsoRemind: 'will also be reminded before meeting',
    kMeetingExpired: 'Meeting Expired',
    kCheckInAttendees: 'Check In for Attendees',
    kSessionCapacityConfirmation:
      'Please confirm that you are attending this session\nCapacity :',
    kMainMenu: 'Main Menu',
    kUserReport:
      'This User has been reported and action will be taken by admin',
    kInboxEmptyTxt: 'Your inbox is empty.',
    kVideoMeetingTxt: 'Video Meeting',
    kUserAlreadyCheckInTxt: 'User already checked in',
    kTxtWhatPost: 'What would you like to post about?',
    kActiveTxt: 'Active',
    kArchiveTxt: 'Archive',
    kScanQRToConnectOthersTxt:
      'Scan this QR for session check-ins &amp; to connect with others',
    kYouWantToBlock: 'Are you sure you want to block?',
    kUserAddedSuccess: 'User added to contacts successfully!',
    kQuickLinks: 'Quick Links',
    kEventGuide: 'Event Guide',
    kCheckedInText: 'Checked in',
    kSearchFilterText: 'Search and Filter',
    kEnterNameKeywordText: 'Enter name or keyword',
    kFetching: 'Fetching',
    kEventText: 'Event',
    kCheckInStatusUpdatedMsg: 'Check In Status updated successfully',
    kUnableToSentMsg: 'Unable to send an email',
    kDummyMsg: "Hi What's up",
    kAllowAppAccess: 'Allow App Access',
    kCameraPermissionMsg:
      'You need to allow camera permission to access camera',
    kScannedSuccessfully: 'Scanned Successfully',

    kUnableToFetchDetails: 'Unable to fetch details',
    kvCardNoteOf: 'vCard note of',
    kAsAnonymous: 'As anonymous',
    kNoReplyAsTheText: 'No reply! Be the first one to reply',
    kHyperLink: 'HyperLink',
    kVisitLink: 'Visit Link',
    kCopyComment: 'Copy comment',
    kAccepted: 'accepted',
    kCancelInvitationMsg: 'Are you sure you want to cancel invitation?',
    kAddMaxPolls: 'You can add a maximum of 2 new polls',
    kEnterMeetingNumToJoin:
      'You need to enter a meeting number/ vanity id which you want to join.',
    kDeletedSuccess: 'Deleted Successfully...',
    kNoteDeleteMsg: 'Are you sure you want to delete the note?',
    kQuestionDeleteMsg: 'Are you sure you want to delete the Question?',
    kLoginAndContinue:
      'Login and complete your profile to connect and start networking with people',
    kReadTxt: 'Read',
    kLetsAddSomething: 'Lets add something',
    kbyTxt: 'By',
    kViewLink: 'View Link',
    kDownloadingTxt: 'Downloading',
    kUpdateCheckinStatus: 'Updating Check In Status',
    kEnterCodeToLogin:
      'Please enter the passcode you have received in your email to login',
    kPleaseSelectUsers: 'Please select Users',
    kPleaseInstallPPT: 'Please install ppt viewer and try again',
    kPleaseInstallPDF: 'Please install pdf viewer and try again',
    kPleaseInstallDOC: 'Please install doc viewer and try again',
    kProfileImageUpdateSuccessMsg: 'Profile image successfully updated',
    kProfileDeleteSuccessMsg: 'Profile is deleted successfully',
    kNoComments: 'No comments!',
    kBeTheFirstOne: 'Be the first one to comment',
    kNoMessages: 'No messages.',
    kNoNotifications: 'No Notifications',
    kNoAppsFoundToOpenFile: 'No applications found which can open the file',
    kTurnOnNetworkingFromProfile:
      'Please turn on networking from profile to start networking',
    kUnableToUploadFile: 'Unable to upload file...',
    kUnableToPost: 'Unable to post',
    kUploadingPhoto: 'Uploading photo please wait...',
    kUploadingVideo: 'Uploading Video please wait...',
    kRemoveFilesMsg: 'Are you sure you want to remove this',
    kDeleteVideoMsg: 'Deleting video please wait...',
    kDeletePhotoMsg: 'Deleting photo please wait...',
    kScanForSearchEvent: 'Scan for searching event',
    kScanForUserLogin: 'Scan for user login',
    kSomethingWentWrongMsg: 'Something went wrong.',
    kExhibitorsTxt: 'Exhibitors',
    kSpeakersTxt: 'Speakers',
    kSponsorsTxt: 'Sponsors',
    kTicketTxt: 'Ticket',
    kJumpToLatest: 'Jump to latest',
    kShowReported: 'Show Reported',
    kNotificationSendErrorMsg: 'Error! while sending notification',
    kIAccept: 'I accept',
    kEnterEmailAddress: 'Enter email address',
    kLogInTxt: 'Log in',
    kTermsConditionsAcceptMsg: 'Please accept terms and conditions',
    kProblem_Signing: 'Problem Signing in?',
    kCameraPermissionTitle: 'Would Like to Access the Camera',
    kCameraGalleryFilesPermissionTitle:
      'Would Like to Access the Camera, Gallery and Files',
    kAllowAccessToCameraForRecordVideo:
      'Allow access to the Camera so you can upload recording videos to',
    kAllowAccessToCameraGalleryFile:
      'Allow access to the Camera, Photo Gallery and files so you can upload photos, files to',
    kAllowAccessToGalleryToShareMap:
      'Allow access to the photo library so you can share the map.',
    kYesterdayTxt: 'Yesterday',
    kPmTxt: 'pm',
    kAmTxt: 'am',
    kImageChooserTxt: 'Image Chooser',
    kNoConversationTxt: 'No Conversations yet',
    kTodayTxt: 'Today',
    kActiveNowTxt: 'Active Now',
    kReminderTxt: 'Reminder!',
    kReminderSessionTxt: 'Reminder for Session',
    kStaringOnTxt: 'staring on',
    kMeetingReminderTxt: 'Meeting reminder at',
    kWithTxt: 'with',
    profile_text_profile: 'Personal',
    profile_form_label_interest: 'Event Tags',
    myprofile_drag_n_drop_or_click: 'Drag and Drop file or Click',
    myprofile_drag_n_drop_or_click_img: 'Drag and Drop image or Click',
    myprofile_drag_n_drop_or_click_video: 'Drag and Drop video or Click',
    myprofile_drag: 'Drag and Drop or Click here to upload image.',
    myprofile_drag_file: 'Drag and Drop or Click here to upload file.',
    myprofile_drag_video: 'Drag and Drop or Click here to upload video.',
    myprofile_click: 'Click here to upload image.',
    myprofile_click_file: 'Click here to upload file.',
    myprofile_click_video: 'Click here to upload video.',
    myprofile_drag_res:
      'Drag and Drop or Click here to upload image. Image size must be {IMAGERES} px.',
    myprofile_click_res:
      'Click here to upload image. Image size must be {IMAGERES} px.',
    'Form labels and placeholders': '',
    form_label_firstname: 'First Name',
    form_ph_firstname: 'Enter your first name',
    form_label_lastname: 'Last Name',
    form_ph_lastname: 'Enter your last name',
    form_label_coupon_code: 'Enter coupon code',
    form_label_company: 'Company',
    form_ph_company: 'Enter company name',
    form_ph_position: 'Enter position in the company',
    form_ph_country: 'Select country',
    form_ph_about: 'Enter about yourself',
    form_ph_email: 'Enter your email',
    form_label_phone: 'Phone No.',
    form_ph_phone: 'Enter your contact number',
    form_label_facebook: 'Facebook Profile',
    form_ph_facebook: 'Enter your facebook profile link',
    form_label_linkedin: 'Linkedin Profile',
    form_ph_linkedin: 'Enter your linkedin profile link',
    form_label_twitter: 'Twitter Profile',
    form_ph_twitter: 'Enter your twitter profile link',
    form_label_attachments: 'Files/Presentations',
    form_label_logo: 'Logo',
    form_label_banner: 'Banner',
    form_label_name: 'Name',
    form_ph_name: 'Enter name here',
    form_label_description: 'Description',
    form_ph_description: 'Enter description here',
    form_label_contact_person: 'Contact Person',
    form_ph_contact_person: 'Enter contact person name',
    form_label_videolink: 'Video Link',
    form_ph_videolink: 'Enter youtube or vimeo video url',
    form_label_title: 'Enter title',
    'Alert Messages': '',
    profile_alert_success: 'Profile updated successfully!',
    speaker_profile_alert_success: 'Speaker profile updated successfully!',
    sponsor_profile_alert_success: 'Sponsor profile updated successfully!',
    exhibitor_profile_alert_success: 'Exhibitor profile updated successfully!',
    exhibitor_profile_alert_error1:
      'Exhibitor logo not updated successfully, try again!',
    exhibitor_profile_alert_error2:
      'Exhibitor banner not updated successfully, try again!',
    exhibitor_banner_click_for_full_view: 'Click for full view',
    dynamic_form_max_file_upload: 'Max file upload reached.',
    toast_message_cheers: 'Cheers!',
    toast_message_success: 'Success!',
    toast_message_warning: 'Warning!',
    toast_message_error: 'Error!',
    Validations: '',
    requird: 'Required',
    invalid_email: 'Invalid email',
    invalid_phone: 'Invalid phone',
    invalid_url: 'Invalid url',
    invalid_fb_url: 'Invalid facebook url',
    invalid_linkedin_url: 'Invalid linkedin url',
    invalid_twitter_url: 'Invalid twitter url',
    required_terms_condition: 'Check the terms & conditions.!',
    invalid_profile_image_size:
      'Image is smaller than recommended image, upload another image.!',
    button_save: 'Save',
    button_hide: 'Hide',
    button_yes: 'Yes',
    button_remove: 'Remove',
    button_crop: 'Crop',
    button_crop_and_save: 'Crop & save',
    button_new_product: 'Add Another Product',
    button_new_deal: 'Add Another Deal',
    button_new_coupon: 'Add Another Coupon',
    common_error_unauth_call:
      'Unexpected error occured. Report this to your organisers.',
    common_error_while_processing: 'Error occured while processing request',
    common_error_while_refreshing: 'Error occured while refreshing list',
    common_too_many_clicks: 'Please avoid multiple clicks.',
    total: 'Total',
    time_day_caps: 'DAY(S)',
    time_hour_caps: 'HRS',
    time_minute_caps: 'MIN',
    time_second_caps: 'SEC',
    anonymous_short: 'AN',
    sorry: 'Sorry',
    pull_down_to_refresh: 'Pull down to refresh',
    relese_to_refresh: 'Release to refresh',
    attachment: 'Attachment',
    file: 'File',
    media: 'Media',
    copied: 'Copied',
    make_call: 'Make Call',
    match: 'Match',
    user: 'User',
    click_here: 'Click here',
    show: 'Show',
    common_not_applicable: 'NA',
    common_exit: 'Exit',
    common_mode: 'Mode',
    button_schedule: 'Schedule',
    button_send: 'Send',
    button_signup: 'Signup',
    button_yes_sure: 'Yes, sure',
    button_no_not_now: 'No, not now',
    button_upload_new_image: 'Upload New Image',
    button_buy_session: 'Buy This Session',
    button_access_session: 'Access This Session',
    button_buy_ticket: 'Buy Ticket',
    button_register_here: 'Register Here',
    button_get_direction: 'Get Directions',
    button_view_notes: 'View Notes',
    button_reject_invitation: 'Reject Invitation',
    button_feed_back: 'Feedback',
    button_send_enquiry: 'Send Enquiry',
    login_form_ph_email: 'Enter your email address',
    login_form_label_password: 'Passcode / Eventcode',
    login_form_ph_password: 'Enter passcode / eventcode',
    login_text_dont_have_account: "Don't have an account?'",
    login_forgot_pass_code: 'Forgot passcode ?',
    login_resend_welcome_mail: 'Resend Welcome Email',
    login_enter_registered_email: 'Enter your registered email',
    login_error_text_invalid_email_password: 'Invalid email or password!',
    login_error_text_user_on_waitlist:
      'You are on the wait list for this event. Please contact event organizers.',
    login_error_token_error: 'You faced a session-token error.',
    signup_error_already_registered:
      'Email already registered with this event!',
    signup_text_already_an_account: 'Already have an account?',
    logout_confirm_subtext: 'Continue to logout?',
    event_overview_text_ticket_buy: 'Buy Ticket',
    event_overview_text_registration_details: 'Booking Details',
    event_overview_text_user_details: 'User Info',
    event_overview_text_view_receipt: 'View Receipt',
    event_overview_text_support_email: 'Contact Organizer',
    event_overview_text_speaker_details: 'Speaker Details',
    event_overview_text_sponsor_details: 'Sponsor Details',
    event_overview_text_exhibitor_details: 'Exhibitor Details',
    event_overview_text_event_location: 'Event Location',
    event_overview_text_view_less: 'View Less',
    session_text_session_videos: 'Session Videos',
    session_text_session_noaccess:
      'Sorry! you do not have permission to access this session.',
    session_polls_text_poll_result_total_count: 'Total Count',
    session_qa_modal_title: 'Session Q&A',
    session_poll_list_modal_title: 'Session Polls',
    session_video_modal_view_on_site: 'view on site',
    session_back_to_list: 'To List',
    exhibitors_no_map_Associated: 'No map is associated',
    polls_title_ans_to_poll: 'Answer to This Poll',
    myticket_th_ticket_ref: 'Ticket Ref',
    myticket_th_ticket_name: 'Ticket Name',
    myticket_th_ticket_orderno: 'Order',
    myticket_th_ticket_order_invoice: 'Invoice',
    myticket_text_order_details: 'Ticket Order Details',
    myticket_text_order: 'Order Details',
    no_liveqa_yet: 'No Live QA Available',
    no_qa_message: 'No Question Asked Yet',
    no_chat: 'No Chat Available',
    no_gallery: 'No Gallery Image Available',
    no_survey: 'No Survey Available',
    no_speaker: 'No Speaker Available',
    no_agenda: 'No agenda Available For Selected Date',
    no_news: 'No News Available',
    no_bookmark: 'No Bookmark Available',
    no_page: '404 Page not found, sorry. Try something else.',
    no_suggested_contact: 'No Suggested Contacts Available',
    no_notes: 'No Notes Created',
    no_notifications: 'No Notifications',
    no_search_result_found: 'No search results found',
    no_webview: 'No data is set for webview.',
    no_interest_selected: 'No interest is selected',
    no_interests_found: 'No interests found',
    no_categories: 'No categories available',
    no_community_category: 'No Community Available',
    no_maps_found: 'No maps found for this event',
    no_match_found: 'Sorry, no match found',
    chat_text_your_chat_request_denied: 'Your chat request has been rejected',
    chat_text_you_denied_chat_request: 'You have rejected this chat request',
    have_been_invited_text: "You've been invited for a chat.",
    chat_browser_not_support_video:
      'Your browser does not support the video tag.',
    chat_browser_not_support_audio:
      'Your browser does not support the audio element.',
    chat_invitation_sent_to: 'Invitation sent to ',
    chat_invitation_received_from: 'Invitation received from',
    KFromText: 'From',
    KAddHours: '+ Add Hours',
    checkout_title_checkout: 'Checkout',
    checkout_text_summary: 'Order Summary',
    checkout_text_coupon_code: 'Apply Coupon Code',
    checkout_text_payment_by: 'Secure Payments by',
    checkout_error_token: 'Stripe token error!',
    event_overview_text_event_shcedule: 'Event Schedules',
    kMutualInterest: 'Mutual Interest',
    attendee_text_interest: 'Interest',
    attendee_text_social_acc: 'Social Accounts',
    attendee_text_invite_rejected: 'Invitation denied',
    attendee_choose_category: 'Choose a category',
    attendee_choose_categories: 'Choose categories',
    community_discussion: 'Discussion',
    requested: 'Requested',
    membership_cancelled: 'Membership Cancelled',
    social_menu_text: 'Social',
    social_feed_add: 'Create a post',
    game_pts: ' pts',
    game_rewarded: 'You have been rewarded',
    survey_modal_mandatory: 'Mandatory Survey',
    rescheduled_sucess: 'Meeting Rescheduled successfully',
    meeting_cancel_blocked: 'Can not cancel as user is/has blocked',
    meeting_scheduled_with: 'Meeting scheduled with',
    meeting_enter_date_time: 'Enter Date and Time',
    no_eventguide: 'No Event Guide',
    no_eventguide_ph: 'Event Guide will appear as soon as they are added.',
    notification_placeholder:
      'Notifications will appear here as soon as they are added. Please check back later',
    notification_is_deleted: ' is deleted',
    notification_is_submitted: ' is submitted',
    globalsearch_recent_searches: 'Recent searches',
    myscan_data_found: ' scan(s) found',
    myscan_profile_linked_exh: 'Linked Exhibitor',
    myscan_profile_linked_spn: 'Linked Sponsor',
    myscan_scanned_note: 'Scanned Note',
    myscan_export_modal_test: 'How would you like to export',
    kPrinterTypeText: 'Select Printer',
    kCalibrateText: 'Calibrate',
    kSelectPrinterText: 'Select Printer',
    kSelectResolutionText: 'Select Resolution',
    kResolutionText: 'Resolution (dpi)',
    kPortText: 'Port (9100)',
    kCalibrateErr: 'Unable to calibrate.',
    kPrinterOutOfService: 'Printer out of service.',
    kZebraPrintErr: 'Unable to fetch media for print.',
    kApproveText: 'Approve',
    kPollOptionsSame:
      'Some options are similar to others. Please enter different options',
    kSearchNotes: 'Search Notes',
    kEnquiry: 'Enquiry',
    kDropVCard: 'Drop vCard',
    kPromoVideo: 'Promo Video',
    kOpenCamera: 'Open Camera',
    kNew: 'New',
    kViewAllProducts: 'View All Products',
    KProductText: 'Products',
    kGamificationPopupSubTitle:
      'Compete with other atteendeen to see who can earn the most poinst and climb up the leaderboard',
    kGamificationPoint_one:
      'You can earn points for commenting, linking, completing your profile etc',
    kGamificationPoint_two:
      'There are hidden bonus points for various activities',
    kGamificationPoint_three:
      'Some challenges/activities will have extra reward like certificates, coupons, offers that you can collect',
    kGamificationPoint_four: "Check out the leaderboard on what's your ranking",
    kGamificationPoint_five: 'Exciting rewards for the toppers!',
    kUserAlreadyAddedToContactTxt: 'User already  added to contacts!',
    kImageDeleted: 'This image has been deleted.',
    kAdImageToSave: 'Please add image to save.',
    kAddGallery: 'Add Gallery',
    kAddYouCaption: 'Add your caption here',
    kShare: 'Share',
    kLastJobPosted: 'Last job posted',
    kLastAnswerPosted: 'Last answer posted',
    kLastMeetupPosted: 'Last meetup posted',
    kEventNotStarted:
      'The Event has not begun. Please check back later for more details.',
    kYouGoing: "You're Going",
    kSendRequest: 'Send Request',
    kGuestUserShort: 'GU',
    kVcardInputPlaceholder: 'Write your contact information with a small note',
    kExportFailed:
      'We are unable to export the list currently. Please try later',
    kLoadingSuggested: 'Loading contact list, please wait...',
    kChooseMap: 'Choose navigation map',
    kGoogleMap: 'Google Map',
    kAppleMap: 'Apple Map',
    kLocation: 'Location',
    Community: '',
    kIntroduceYourself: 'Introduce Yourself',
    kIntroduction: 'Introduction',
    kIntroductionPlaceholder: 'Write a short introduction note here...',
    kIceBreakerQuestion: 'Icebreaker Question',
    kYourAnswer: 'Your Answer',
    kEnterAnswer: 'Enter your answer',
    kMeetupType: 'Meetup Type',
    kInPerson: 'In-Person',
    kVirtual: 'Virtual',
    kMeetupTitle: 'Meetup Title',
    kMeetupTitlePlaceholder: 'Enter a title for your meetup',
    kMeetupDesc: 'Meetup Description',
    kMeetupDescPlaceholder: 'Write a short description for your meetup',
    KWriteShortNoteplaceholder: 'Write a short note...',
    kMeetupDate: 'Meetup Date & Time',
    KDateAndTime: 'Date & Time',
    kMeetupLocation: 'Meetup Location',
    kMeetupLocationPlaceholder: 'Enter a Location',
    KMeetingNotes: 'Meeting Notes',
    kJobTitle: 'Job Title',
    kJobTitlePlaceholder: 'Enter a job title',
    kJobDesc: 'Job Description',
    kJobDescPlaceholder: 'Write a brief job description',
    kJobType: 'Job Type',
    kJobPartTime: 'Part-time',
    kJobFullTime: 'Full-time',
    kJobLocation: 'Job Location',
    kExportApplicants: 'Export Applicants',
    kApplyForJob: 'Apply for this Job',
    kRevokeApplication: 'Revoke My Application',
    kPersonApplied: 'Person(s) applied',
    kLinkedExhibitor: 'Linked Exhibitor',
    kLinkedExhibitorPlaceholder: 'Select an Exhibitor',
    kWhenApply: 'When Apply',
    kCollectAsLeads: 'Collect as Leads',
    kOpenExternalUrl: 'Open External URL',
    kExternalUrl: 'External URL',
    kExternalUrlPlaceholder: 'Enter External URL',
    kTapToOpenChat: 'Tap to open chat',
    kSelectDocument: 'Choose Document',
    kImageGallery: 'Image Gallery',
    kVideoGallery: 'Video Gallery',
    kCapturePhoto: 'Capture Photo',
    kCaptureVideo: 'Capture Video',
    kAddingSocialPost: 'Your post is on its way.',
    kYouWillGet: 'You will get',
    kForEveryActivity: 'for every activity',
    kDocument: 'Document',
    kThisEmailNotRegistered: 'This email is not registered in the event',
    kTakePhoto: 'Take Photo',
    kTakeVideo: 'Take Profile Video',
    kUploadPhoto: 'Upload Photo',
    kUploadVideo: 'Upload Profile Video',
    kAddFrame: 'Add a Frame',
    kRemoveProfilePic: 'Remove Profile Picture',
    kRemoveProfileVideo: 'Remove Profile Video',
    kRateSessionSubtitle:
      'We would love to know. This will help us improve our future sessions.',
    kReplyingTo: 'Replying to',
    kReplyCancel: '... Cancel ?',
    kAudioLimit: 'Audio recording is limited to 15 seconds',
    kPlay: 'Play',
    kSessionDiscussion: 'Session Discussions',
    kAdd: 'Add',
    kJoinMeeting: 'Join Meeting',
    kFollowPost: 'Follow Post',
    kUnFollowPost: 'UnFollow Post',
    kSupport: 'Support',
    kRSVPOverlaping:
      'You have another session in your Agenda at the same time. Please check again.',
    kRSVPFull:
      'Sorry! all seats are reserved for this session. Please check back later.',
    kUpcomingMeetings: 'You have ###COUNT### upcoming meetings',
    kMeetingLink: 'Meeting Link',
    kAlreadyRSVPd: "You have already RSVP'd to a session in the same time",
    kSessionExhibitorText: 'Session Exhibitors',
    kSessionSponsorText: 'Session Sponsors',
    kRemote: 'Remote',
    kUploadingSocial: 'Please wait, adding your post...',
    kSearchPrinters: 'Search Printers',
    kTestPing: 'Test Ping',
    kStopPing: 'Stop Ping',
    kSelectPrinter: 'Select Printer',
    kSearching: 'Searching...',
    kNoContentText: 'No content',
    kNoContentSubtext: 'Looks like the host has not added any content(s) yet.',
    kNoContentGeneric: 'No content(s) added yet.'
    // ==============================================
    // Existing language properties ends
    // ==============================================

    // ==============================================
    // New language properties starts (PROPOSED)
    // ==============================================
    // ==============================================
    // New language properties ends (PROPOSED)
    // ==============================================
  }
});

// module.exports = LocalStrings;
export default LocalStrings;
